import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/meshes.svg
 */
const IconMeshes: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M7.758 22.096l3.808-1.903v1.206l-2.607 1.303-1.2-.606zm-2.172-1.085l5.98-2.99v1.207l-4.78 2.39-1.2-.607zm-2.172-1.087l8.152-4.075v1.207l-6.952 3.475-1.2-.607zm-2.172-1.087l10.324-5.16v1.207l-9.124 4.564-1.2-.61zm-.102-2.119l10.426-5.213v1.207L1.14 17.927v-1.208zm0-.972V14.54l8.687-4.346 1.208.604-9.895 4.95zm0-2.172v-1.207L7.655 9.11l1.208.604-7.723 3.86zm0-2.171v-1.208l4.343-2.172 1.208.604-5.55 2.775zm0-2.175V8.021l2.172-1.087 1.207.604-3.379 1.69zm0-2.171V5.85l1.208.603-1.208.604zm10.426 15.309V24l-1.637-.817 1.637-.817zm.867-11.296l.63-.313 9.797-4.9v12.93L12.434 24V11.07zM12.002 0l10.323 5.16-9.649 4.831-.674.338L1.676 5.167 12 0z"
      fill="currentColor"
    />
  </svg>
);

export default IconMeshes;
